import { render, staticRenderFns } from "./delete-confirmation.vue?vue&type=template&id=56c5691d&scoped=true&"
import script from "./delete-confirmation.vue?vue&type=script&lang=js&"
export * from "./delete-confirmation.vue?vue&type=script&lang=js&"
import style0 from "./delete-confirmation.vue?vue&type=style&index=0&id=56c5691d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c5691d",
  null
  
)

export default component.exports